import cx from 'classnames';
import React, { useEffect, useState, useMemo } from 'react';
import './index.scss';
import { getClientImage } from '@byted/ecom-mobile-lib/lib/utils/getClientImage';

const ONE_PIXEL_TRANSPARENT_PNG =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const ImageComponent: React.FC<{ src: string; className?: string; size?: number }> = ({
    src,
    className,
    size
}) => {
    const [url, setUrl] = useState('');
    const [loaded, setLoad] = useState(false);

    const formatedImage = useMemo(() => {
        if (!size) return src;
        // 默认用三倍图
        const imageSize = size * 3;
        return getClientImage(src, 50, `${imageSize}x${imageSize}`);
    }, [src, size]);

    useEffect(() => {
        const image = new Image();
        image.src = formatedImage;

        const onLoad = () => {
            setLoad(true);
            setUrl(formatedImage);
            removeAllListener();
        };
        const onError = () => {
            setLoad(true);
            removeAllListener();
        };
        const removeAllListener = () => {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };

        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);

        return () => {
            removeAllListener();
        };
    }, [formatedImage]);

    return (
        <div className={cx('image__container', `${className || ''}`)}>
            <div
                data-src={url}
                className="image__container--component"
                style={
                    loaded && url
                        ? {
                              backgroundImage: `url(${formatedImage})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'top'
                          }
                        : {}
                }
            />
            <div className="image__container--mask" />
        </div>
    );
};

export default ImageComponent;
